import { render, staticRenderFns } from "./header-after.vue?vue&type=template&id=0baad97c&scoped=true"
import script from "./header-after.vue?vue&type=script&lang=js"
export * from "./header-after.vue?vue&type=script&lang=js"
import style0 from "@/pages/contract/review/css/style-review.css?vue&type=style&index=0&id=0baad97c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baad97c",
  null
  
)

export default component.exports